const toForm = (exp: any) => {
    return exp.replace(/\\/g, '\\\\');
};
const fromForm = (exp: any) => {
    return exp.replace(/\\\\/g, '\\');
};

export { toForm, fromForm };
